import React, { useEffect, useState } from "react";
import DataTable from "../DRM/components/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { Button, Tab, Typography } from "@mui/material";
import { setAuditResults } from "../../redux/actions/DRM_files.action";
import { setLoading } from "../../redux/actions/DRM_user.action";
import { displayConfirmation, displayLog } from "./common/common";
import { Link } from "react-router-dom";
import moment from "moment";
import { useGridApiRef } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import Box from "@mui/material/Box";
import { axios_tenant } from "../../../axios";
import "./AuditResult.css";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { green, red } from "@mui/material/colors";
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import WarningIcon from "@mui/icons-material/Warning";
import FlagIcon from "@mui/icons-material/Flag";
import { useCategory } from "./components/IpProvider";
import { TabList, TabContext } from "@mui/lab";
import { DateTimeStringFormatter } from "app/utils/date";
const CustomNoRowsOverlay = () => {
        return (
            <Box sx={{
                display: "flex", flexDirection: "column",
                alignItems: "center", margin: 2,
                paddingX: {
                    xs: 3,
                    sm: 0
                },
            }}
            >
                <Typography variant={"h1"} mt={2} textAlign={"center"}>
                    There are no items to show
                </Typography>

                <Typography variant={"body1"} mt={1} mb={2} >
                    Upload documents to get started
                </Typography>
                <Link to="/drm/file-upload">
                    <Button variant="outlined">Upload</Button>
                </Link>
            </Box>
            // </div>
        );
    };

const AuditResult = () => {

    const dispatch = useDispatch();
    const apiRef = useGridApiRef();
    const {
        category,
        switchCategory
    } = useCategory()

    const auditResults = useSelector((state) => state.fileStore.auditResults);
    const loading = useSelector((state) => state.userStore.loading);

    let [selectedRows, setSelectedRows] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filter, setFilter] = React.useState("");
    const [tenantMappings, setTenantMappings] = useState(null);
    const [isAllRowsSelected, setIsAllRowsSelected] = useState(false);
 

    function addSerialNumbers(data) {
        return data.map((item, index) => ({
            ...item,
            serialnumber: index + 1
        }));
    }

    useEffect(() => {
        const auditResults = async () => {
            await getAuditResults();
        }
        auditResults();
    }, []);

    useEffect(() => {
        setSelectedRows([]);
        setIsAllRowsSelected(false);
        apiRef.current?.setRowSelectionModel?.([]);
        apiRef.current?.setPage?.(0);
      }, [category]);

    const currentAuditResults = category === "patent" ? auditResults?.patent || [] : auditResults?.trademark || [];
    const selectableRows = filteredData?.length > 0 ? filteredData : currentAuditResults;
    const totalSelectableRecords = selectableRows.length;

    useEffect(() => {
        const selectableIds = new Set(selectableRows.map((row) => row.id));

        if (isAllRowsSelected) {
            setSelectedRows(Array.from(selectableIds));
            return;
        }

        setSelectedRows((prevSelectedRows) =>
            prevSelectedRows.filter((id) => selectableIds.has(id))
        );
    }, [selectableRows, isAllRowsSelected]);
      
      
      



    const getAuditResults = async () => {
        dispatch(setLoading(true));

        let response = await axios_tenant.get(`/drm/fetchAuditResult/v2?limit=100000&isArchived=0&category=all`).then((res) => res);


        if (response?.status === 200) {
            const tenantMapping = response.data?.data?.tenantMapping || {};
            setTenantMappings(tenantMapping || {});
            dispatch(setAuditResults({
                patent: addSerialNumbers(response.data.data.auditResults.patent.filter((i) => i.is_archived != "1")),
                trademark: addSerialNumbers(response.data.data.auditResults.trademark.filter((i) => i.is_archived != "1"))
            }));

        }


        if (filter) {
            filterTable(filter);
        }

        dispatch(setLoading(false));
    };


    const filterTable = (value) => {
        setFilter(value);

        if (value) {
            let filteredData = currentAuditResults.filter((i) => {
                return String(i.application_number.toLowerCase()).includes(value.toLowerCase()) || String(i.docket_number.toLowerCase()).includes(value.toLowerCase()) || String(i.country.toLowerCase()).includes(value.toLowerCase()) || String(i.field_activity_name.toLowerCase()).includes(value.toLowerCase()) || String(i.issue_description.toLowerCase()).includes(value.toLowerCase()) || String(i.client_name.toLowerCase()).includes(value.toLowerCase());
            });

            setTableData(addSerialNumbers(filteredData));
        } else {
            setTableData(addSerialNumbers(auditResults));
        }
    };

    const columns = [
        {
            field: "serialnumber",
            headerClassName: 'no-active-border',
            headerName: tenantMappings?.serialnumber || "S.N.",
            flex: 0.4
        },
        {
            field: "application_number",
            headerName: tenantMappings?.application_number || "Application No.",
            headerClassName: 'no-active-border',
            sortable: true,
            flex: 1.3
        },
        {
            field: "docket_number",
            headerName: tenantMappings?.docket_number || "Matter ID",
            headerClassName: 'no-active-border',
            sortable: true,
            flex: 1.0
        },
        {
            field: "country",
            headerName: tenantMappings?.country || "Country",
            headerClassName: 'no-active-border',
            sortable: true,
            flex: 1,
            wrap: true,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "audit_result",
            headerName: tenantMappings?.audit_result || "Audit Result",
            headerClassName: 'no-active-border',
            headerAlign: "center",
            align: "center",
             flex: 1,
            renderCell(params) {
                return (<span>
                    {params.row.audit_result === "ERROR" ? (<WarningIcon sx={{ color: red[500] }} />) : (<i style={{ color: "#FFBF00" }}><FlagIcon /></i>)}
                </span>);
            }
        },
        {
            field: "issue_description",
            headerName: tenantMappings?.issue_description || "Issue Description",
            headerClassName: 'no-active-border',
            sortable: true,
            wrap: true,
             flex: 2.0
        },
        {
            field: "client_name",
            headerName: tenantMappings?.client_name || "Client Name",
            headerClassName: 'no-active-border',
            sortable: true,
             flex: 1.8
        },
        {
            field: "foreign_associate",
            headerName: tenantMappings?.foreign_associate || "Foreign Associate",
            headerClassName: 'no-active-border',
            sortable: true,
            flex: 1.5
        },
        {
            field: "status",
            headerName: tenantMappings?.status || "Status",
            headerClassName: 'no-active-border',
            sortable: true,
            flex: 1
        },
        {
            field: "matter_sub_matter_type",
            headerName: tenantMappings?.matter_sub_matter_type || "Filing Type",
            headerClassName: 'no-active-border',
            sortable: true,
            flex: 1.3
        },
        {
            field: "batch_date",
            headerName: tenantMappings?.batch_date || "Batch Date",
            headerClassName: 'no-active-border',
            sortable: true,
            flex: 1,
            valueFormatter: (params) =>
                DateTimeStringFormatter(params.value)
        },
    
        {

            field: "custom_status_description",
            headerName: tenantMappings?.custom_status_description || "Custom Status",
            headerClassName: "no-active-border",
            sortable: true,
            flex: 1.2
        },
        {
        
            field: "priority_date",
            headerName: tenantMappings?.priority_date || "Priority Date",
            headerClassName: "no-active-border",
            sortable: true,
            flex: 1,
            valueFormatter: (params) =>
            params.value ? moment(params.value).format("DD-MMM-YYYY") : ""
        },

        {
            headerName: "Actions",
            headerClassName: 'no-active-border',
            flex: 1,
            renderCell: (params) => (
                <>
                    <Tooltip title="Mark as Corrected">
                        <IconButton size="small" aria-label="Mark as Corrected" onClick={() => handleAction(true, params.row.id)}>
                            <DoneAllIcon fontSize={"small"} sx={{ color: green[500] }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Ignore">
                        <IconButton size="small" aria-label="Ignore" onClick={() => handleAction(false, params.row.id)}>
                            <CloseIcon fontSize={"small"} sx={{ color: red[500] }} />
                        </IconButton>
                    </Tooltip>
                </>
            )
        }
        

    ];

    const handleAction = async (action, id) => {
        let selectedIds = [...selectedRows];
        if (!action) {
            let doNotAsk = localStorage.getItem("doNotAsk");

            if (!doNotAsk) {
                let html = `
					<span>Are you sure you want to ignore ${id ? "this" : "all these"}
						<span class="text-danger">${id ? "ERROR" : "ERRORS"}?</span>
					</span>
					<br /> 
					<br /> 
				`;

                let confirm = await displayConfirmation(html, true);

                if (confirm.value == 1) {
                    localStorage.setItem("doNotAsk", true);
                }

                if (!confirm.isConfirmed) {
                    return;
                }
            }
        }

        if (id) {
            selectedIds = Array.from(new Set([...selectedRows, id]));
            setSelectedRows(selectedIds);
        }

        changeAuditResultStatus(selectedIds, action);
    };

    const changeAuditResultStatus = async (arr, action) => {
        let req = {
            id: arr,
            action_taken: action ? "Corrected" : "Ignored",
            is_managed: action ? "1" : "0",
            who_send: localStorage.getItem("tenant_username")
        };
        let response = await axios_tenant.post(`/drm/updateAuditResult?category=${category}`, req).then((res) => res.data);
        if (response?.success) {
            await getAuditResults();
            apiRef?.current?.setRowSelectionModel([]);
            setSelectedRows([]);
            setIsAllRowsSelected(false);
            displayLog(`${arr.length} ${arr.length === 1 ? "item" : "items"} moved to archive`, "success");
        }
    };


    const handleSelectAllRecords = () => {
        setSelectedRows(selectableRows.map((row) => row.id));
        setIsAllRowsSelected(true);
    };

    const handleClearSelection = () => {
        setSelectedRows([]);
        setIsAllRowsSelected(false);
        apiRef.current?.setRowSelectionModel?.([]);
    };

    const csvRows = (() => {

    if (selectedRows.length > 0) {
        return currentAuditResults.filter((row) =>
            selectedRows.includes(row.id)
        );
    }

    if (filteredData.length > 0) {
        return filteredData;
    }

    return currentAuditResults;

})();

    const customToolbar = () => {
        return (
            <Box sx={{
                display: "flex",
                justifyContent: "flex-end", gap: 2,
                alignItems: 'center'
            }}>
                {/* <ButtonGroup size="small" variant="outlined" aria-label="small button group"> */}
                <Button
                    startIcon={<DoneAllIcon />}
                    size="small"
                    onClick={() => handleAction(true)}
                >
                    Corrected
                </Button>
                <Button
                    startIcon={<CloseIcon />}
                    size="small"
                    onClick={() => handleAction(false)}
                >
                    Ignore
                </Button>

                <CSVLink
                data={csvRows
                .map((row) => {
                            // Create a new object for each row
                            let newRow = {};
                            // Iterate over each column
                            columns.forEach((column) => {
                                // Use the headerName as the key and get the corresponding value from the row
                                // newRow[column.headerName] = row[column.field];
                                const header =
                                tenantMappings?.[column.field] || column.headerName;
                              
                              newRow[header] =
                                typeof row[column.field] === "number"
                                  ? row[column.field].toString()
                                  : row[column.field];
                              
                            });
                            const localDate = new Date(row.batch_date);

                            newRow['Batch Date'] = [
                            String(localDate.getDate()).padStart(2, "0"),
                            String(localDate.getMonth() + 1).padStart(2, "0"),
                            localDate.getFullYear(),
                            ].join("/");
                            newRow['Batch Time'] = (new Date(row.batch_date)).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                           newRow['Priority Date'] = row.priority_date || '';

                            delete newRow.Actions;
                            return newRow;
                        }
                        )}
                    // export file with category name
                    filename={category + "_audit_result.csv"}
                >
                    <Button
                        startIcon={<FileDownloadIcon />}
                        size="small"
                    >
                        Export As CSV
                    </Button>
                </CSVLink>
                {/* <GridToolbarExport/> */}
                {/* <GridToolbarQuickFilter /> */}
                {/* </ButtonGroup> */}
            </Box>
        );
    };

    const selectionToolbar = () => {
        if (!selectedRows.length) {
            return null;
        }

        if (isAllRowsSelected) {
            return (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    All {totalSelectableRecords} records selected.{" "}
                    <Button
                        size="small"
                        variant="text"
                        onClick={handleClearSelection}
                        sx={{ minWidth: "auto", padding: 0, textTransform: "none", verticalAlign: "baseline" }}
                    >
                        Clear Selection
                    </Button>
                </Typography>
            );
        }

        return (
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {selectedRows.length} records selected.{" "}
                <Button
                    size="small"
                    variant="text"
                    onClick={handleSelectAllRecords}
                    sx={{ minWidth: "auto", padding: 0, textTransform: "none", verticalAlign: "baseline" }}
                >
                    Click Here
                </Button>{" "}
                to select all {totalSelectableRecords} records.
            </Typography>
        );
    };

    const handleTabChange = (event, newValue) => {
        switchCategory(newValue);
    };
    const recordCount = currentAuditResults.length;
    const recordLabel =
        `${recordCount} ${recordCount === 1 ? "Record" : "Records"}`;
    let content;

    if (tenantMappings === null) {
        content = <div>Loading...</div>;
    } else if (
        !(auditResults?.patent?.length || auditResults?.trademark?.length) &&
        !loading
    ) {
        content = <CustomNoRowsOverlay />;
    } else {
        content = (
            <DataTable
                columns={columns}
                data={currentAuditResults}
                checkboxSelection
                apiRef={apiRef}
                loading={loading}
                setLoading={setLoading}
                customToolbar={customToolbar}
                toolbarLeftComponent={selectionToolbar}
                initialState={{
                    columns: {
                        columnVisibilityModel:
                            tenantMappings?.columnVisibilityModel || {
                                client_name: false,
                            },
                    },
                }}
                showToolbar={true}
                selectableRows={true}
                rowSelectionModel={selectedRows}
                onRowSelectionModelChange={(newSelection) => {
                    setSelectedRows(newSelection);
                    setIsAllRowsSelected(
                        newSelection.length > 0 &&
                        newSelection.length === totalSelectableRecords
                    );
                }}
                onFilteredDataChange={setFilteredData}
                className="data-grid"
                getRowClassName={(params) =>
                    params.row.is_duplicate == "1" ? "duplicate-row" : ""
                }
                getRowHeight={() => "auto"}
                sx={{
                    "&": {
                        fontSize: "0.825rem",
                    },
                    "& .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-cellContent": {
                        whiteSpace: "normal",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        lineHeight: 1.5,
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        position: "sticky",
                        top: 80,
                        zIndex: 1000,
                        backgroundColor: "#fff",
                    },
                    "& .MuiDataGrid-main": {
                        overflow: "unset !important",
                    },
                }}
            />
        );
    }
    return (
        <div className="">
            {/* <ContactsList/> */}
            {/* <AuditResultsTable bulk = {changeAuditResultStatusBulk} /> */}
            <Box sx={{
                marginBottom: "20px"
            }}>
                <TabContext value={category}>
                    <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                        <Tab label={`Patent`} value="patent" />
                        <Tab label={`Trademark`} value="trademark" />
                    </TabList>
                </TabContext>
            </Box>
            <div className="mr-2 d-flex justify-content-between">
                <span>
                    Audit Result{" "}
                    <span className="label text-secondary">
                        {/* ({auditResults.length} {auditResults.length === 1 ? "Record" : "Records"}) */}
                        ({recordLabel})
                    </span>
                </span>
                <br />
            </div>

            <div className="mt-3">
                {content}

            </div>
        </div>
    );
};

export default AuditResult;
